import React from 'react';
import { Button } from './ui/button';
import { Users } from 'lucide-react';
import { toast } from './ui/use-toast';
import { RandomCompanies } from './RandomCompanies';
import { useCompanies } from '../hooks/useCompanies';

export const ICPVibeMethod: React.FC = () => {
  const { companies, addCompanies } = useCompanies();

  const handleAddRandomCompany = (companyName: string, type: 'good' | 'bad') => {
    return addCompanies([companyName], type);
  };

  const generateICP = () => {
    const goodExamples = companies.filter(c => c.type === 'good');
    if (goodExamples.length === 0) {
      toast({
        title: "No good examples",
        description: "Please add at least one good example company.",
        variant: "destructive"
      });
      return;
    }

    console.log('Generating ICP from companies:', companies);
    toast({
      title: "Generating ICP",
      description: "Creating your ideal customer profile based on the companies you provided...",
    });
  };

  const goodExamples = companies.filter(c => c.type === 'good');

  return (
    <div className="space-y-6">
      {/* Help Message */}
      <div className="text-slate-300 text-sm">
        Search for companies and vote on whether they represent your ideal customers (good examples) or companies that don't fit your target (bad examples). Your progress will be saved automatically.
      </div>

      {/* Random Companies Section */}
      <RandomCompanies onAddCompany={handleAddRandomCompany} />

      {/* Generate ICP Button */}
      <Button 
        onClick={generateICP}
        disabled={goodExamples.length === 0}
        className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white border-0"
      >
        <Users className="w-4 h-4 mr-2" />
        Generate My ICP
      </Button>
    </div>
  );
}; 